export const TIPO_REFERENCIAS = {
  VECINAL: 1,
  PERSONAL: 2,
  COMPAÑEROS_TRABAJO: 3,
  JEFE_INMEDIATO: 4,
  JEFE_ANTERIOR: 5,
}

export const TIPO_REFERENCIAS_LABORALES = [
  TIPO_REFERENCIAS.COMPAÑEROS_TRABAJO,
  TIPO_REFERENCIAS.JEFE_INMEDIATO,
  TIPO_REFERENCIAS.JEFE_ANTERIOR,
]
